webpackJsonp([1],{

/***/ "+Bx8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['meta', 'attachments'],
  data: function data() {
    return {
      label: 'Addon'
    };
  },
  methods: {
    close: function close() {
      this.$emit('closeAddon');
    }
  }
});

/***/ }),

/***/ "+NmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/0jp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/HT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function postUser(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'put',
    url: 'user',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    },
    data: data
  });
}

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("QOuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0J+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__("VzzP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4221fc35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__("Fg7u");
function injectStyle (ssrContext) {
  __webpack_require__("5vho")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4221fc35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4221fc35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0PFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_en_gb__ = __webpack_require__("hPuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_locale_en_gb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_locale_en_gb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_de__ = __webpack_require__("DOkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['campaign'],
  data: function data() {
    return {
      menu: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    impressions: function impressions() {
      return 0;
    },
    statusLabel: function statusLabel() {
      return this.$t('campaigns.statuses.' + this.campaign.status);
    },
    statusClass: function statusClass() {
      return ['fa-grey', 'fa-orange', 'fa-green', 'fa-blue'][this.campaign.status];
    },
    durationLabel: function durationLabel() {
      var start = new Date(this.campaign.start);
      var end = new Date(this.campaign.end);
      var options = {
        timeZone: 'Europe/Vienna'
      };
      return start.toLocaleDateString(this.lang, options) + ' - ' + end.toLocaleDateString(this.lang, options);
    },
    durationHuman: function durationHuman() {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(this.lang);

      var start = new Date(this.campaign.start);
      var end = new Date(this.campaign.end);
      var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()(start).from(__WEBPACK_IMPORTED_MODULE_1_moment___default()(end).add(1, 'days'), true);
      return diff;
    },
    createdDate: function createdDate() {
      var created = new Date(this.campaign.created);
      return created;
    },
    progress: function progress() {
      var self = this;
      var c = self.campaign;
      if (c.status < 2) {
        return 0;
      } else if (c.status === 3) {
        return 100;
      } else {
        var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default()(c.end).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(c.start), 'days');
        var span = __WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(self.campaign.start), 'days');
        if (span < duration) {
          return Math.floor(span / duration * 100);
        } else {
          return 100;
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['lang'])),
  methods: {
    dropdown: function dropdown() {
      this.menu = !this.menu;
    },
    hide: function hide() {
      this.menu = false;
    }
  }
});

/***/ }),

/***/ "0Vif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("Yy+i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d4209e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("ZGSf");
function injectStyle (ssrContext) {
  __webpack_require__("Vibr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42d4209e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d4209e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0j7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAccount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function deleteAccount(email) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'delete',
    url: 'user/delete',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    }
  });
}

/***/ }),

/***/ "2k+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CockpitSelector_vue__ = __webpack_require__("trxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CockpitHeader_vue__ = __webpack_require__("3Ybh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CockpitMap_vue__ = __webpack_require__("3gbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoData_vue__ = __webpack_require__("sqAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Error_vue__ = __webpack_require__("0J+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cockpit',
  components: {
    CockpitSelector: __WEBPACK_IMPORTED_MODULE_0__CockpitSelector_vue__["a" /* default */], CockpitHeader: __WEBPACK_IMPORTED_MODULE_1__CockpitHeader_vue__["a" /* default */], CockpitMap: __WEBPACK_IMPORTED_MODULE_2__CockpitMap_vue__["a" /* default */], NoData: __WEBPACK_IMPORTED_MODULE_3__NoData_vue__["a" /* default */], Error: __WEBPACK_IMPORTED_MODULE_4__common_Error_vue__["a" /* default */]
  },
  data: function data() {
    return {
      campaign_id: null,
      campaigns: [],
      loading: false,
      hasData: true,
      mapLoading: false,
      error: false,
      selectedCampaign: null
    };
  },
  created: function created() {
    var self = this;
    self.loading = true;
    self.$Progress.set(25);
    self.buildMenu(1).then(function () {
      self.$Progress.finish();
      self.loading = false;
      self.campaign_id = self.campaigns.length ? self.campaigns[0].id : null;
      self.hasData = self.campaigns.length > 0;
    }).catch(function (e) {
      self.$Progress.fail();
      self.loading = false;
      self.error = e.response.data.error;
    });
  },

  computed: {
    campaignsList: function campaignsList() {
      return this.campaigns.map(function (c) {
        return {
          id: c.id,
          name: c.name
        };
      });
    }
  },
  watch: {
    campaign_id: function campaign_id() {
      var self = this;
      this.mapLoading = true;
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getCampaign(self.campaign_id).then(function (r) {
        self.mapLoading = false;

        self.selectedCampaign = r.data.data;
      });
    }
  },
  methods: {
    loadingFinished: function loadingFinished() {
      this.loading = false;
    },
    buildMenu: function buildMenu(page) {
      var self = this;

      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getCampaigns({ page: page }).then(function (r) {
        self.campaigns = self.campaigns.concat(r.data.data);
        if (r.data.links.next) {
          self.buildMenu(page + 1);
        }
      });
    }
  }
});

/***/ }),

/***/ "3Ybh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitHeader_vue__ = __webpack_require__("t2fV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148d16a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitHeader_vue__ = __webpack_require__("pLvq");
function injectStyle (ssrContext) {
  __webpack_require__("sQf1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-148d16a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148d16a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3gbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitMap_vue__ = __webpack_require__("fFe+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f768eef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitMap_vue__ = __webpack_require__("BWRi");
function injectStyle (ssrContext) {
  __webpack_require__("vv34")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f768eef4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f768eef4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ujs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitSwitch_vue__ = __webpack_require__("Mg9V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa81332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitSwitch_vue__ = __webpack_require__("RCb4");
function injectStyle (ssrContext) {
  __webpack_require__("9Fgk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4aa81332"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa81332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "46x1":
/***/ (function(module, exports) {

module.exports = {"campaigns":{"action":"Aktion","addons":{"carmob":{"desc":"Parken an gewünschten hoch frequentierten Orten in der Stadt. Aktiviert per Direct-Messages an die Fahrzeuglenker.","title":"Carmob"},"incar":{"desc":"Dispenser, Audio, Video u.v.m... Machen Sie das Fahrerlebnis zu Ihrem Markenerlebnis.","title":"In-Car Branding"},"layout":{"desc":"Lassen Sie das passende Fahrzeug- Branding auf Basis Ihres Corporate Designs ganz einfach von Folyo erstellen.","title":"Layout von Folyo"},"retargeting":{"desc":"Notifications ganz einfach auf die Smartphones der umstehenden Fußgänger spielen. So sprechen Sie Ihre Zielgruppe 2x an.","title":"Re-Targeting"},"title":"Add-Ons"},"budget":"Budget","budget_spent":"Kosten bisher","city":"Stadt","created":"Erstellt am","created_by":"Ersteller","created_on":"Erstellt am","cust_detail":"Kundendaten","duration":"Dauer","fleet":"Flotte","header":"Kampagne | Kampagnen","impressions":"Impressions","impressions_ttl":"Impressions (Insg.)","impressions_zone":"Impressions (Zone)","location":"Location & Time","menu":{"details":"Kampagnen Details"},"name":"Kampagnenname","progress":"Fortschritt","status":"Status","status_label":"Kampagnestatus","statuses":{"0":"Entwurf ","1":"In Vorbereitung (Folyo) ","2":"On the Road ","3":"Ausgerollt "},"timezone":"Zeitfenster","vehicles":"Fahrzeuge","zone":"Zone"},"delete":{"action":"Um fortzufahren, bestätigen Sie bitte die mit diesem Konto verknüpfte E-Mail.","btn":{"cancel":"STORNIEREN","delete":"LÖSCHEN"},"head":"Deinen Account löschen?","subhead":"Sie sind dabei, die Löschung Ihres Kontos anzufordern. Bitte beachten Sie, dass die Bearbeitung der Anfrage bis zu 48 Stunden dauern kann. In diesem Zeitraum ist Ihr Konto nicht mehr erreichbar.","warning":"Nach dem Löschen können die Kontodaten nicht wiederhergestellt werden."},"language":"Sprache","loading":"Lädt","login":{"back":"Zurück zum Login","click_here":"hier klicken.","delete":"Konto löschen","driver_dash":"Für das Drivers Dashboard,","email":"E-mail","forgot":"Passwort vergessen?","header":"Marken & Werber","invitation_code":"Einladungscode","login_btn":"LOGIN","name":"Name","no_login":"Sie haben noch keinen Login?","password":"Passwort","password_repeat":"Passwort wiederholen","password_reset":{"heading":"Passwort wiederherstellen","info":"Geben Sie Ihre registrierte E-Mail Adresse an. Wir senden Ihnen einen Wiederherstellungslink.","sent_info":"Kontrollieren Sie Ihr Postfach. Wir haben Ihnen einen Wiederherstellungslink an untenstehende E-Mail Adresse gesendet.","set_new":"Please set a new password"},"register_now":"Jetzt registrieren","registered_on":"Registriert am","registration":"Registrierung","registration_check":"Kontrollieren Sie Ihr Postfach. Wir haben Ihnen einen Bestätigungslink an untenstehende E-Mail Adresse gesendet.","subheader":"Login","teams":"Teams","terms":"AGB","understood":"Ich habe die {0} gelesen und bin mit Ihnen einverstanden.","update":"Update"},"noshow":"Keine Daten vorhanden","noshowsub":"Keine Daten vorhanden die angezeigt werden könnten","sidebar":{"campaigns":"Kampagnen","cockpit":"Cockpit"},"terms":{"contact":"Kontakt","headline":"Datenschutz","p1":"Durch den Besuch des Internetauftritts können Informationen (Datum, Uhrzeit, aufgerufene Seite) über den Zugriff auf dem Server gespeichert werden. Es werden keine personenbezogenen (z. B. Name, Anschrift oder E-Mail-Adresse) Daten, gespeichert.","p2":"Sofern personenbezogene Daten erhoben werden, erfolgt dies, sofern möglich, nur mit dem vorherigen Einverständnis des Nutzers der Webseite. Eine Weitergabe der Daten an Dritte findet ohne ausdrückliche Zustimmung des Nutzers nicht statt.","p3":"Der Anbieter weist darauf hin, dass die Übertragung von Daten im Internet (z. B. per E-Mail) Sicherheitslücken aufweisen und ein lückenloser Schutz der Daten vor dem Zugriff Dritter nicht gewährleistet werden kann. Der Anbieter übernimmt keine Haftung für die durch solche Sicherheitslücken entstandenen Schäden.","p4":"Der Verwendung der Kontaktdaten durch Dritte zur gewerblichen Nutzung wird ausdrücklich widersprochen. Es sei denn, der Anbieter hat zuvor seine schriftliche Einwilligung erteilt. Der Anbieter behält sich rechtliche Schritte für den Fall der unverlangten Zusendung von Werbeinformationen, z. B. durch Spam-Mails, vor.","provider":"Provider"},"topnav":{"logout":"Abmelden","settings":"Einstellungen"}}

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5PKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignItem_vue__ = __webpack_require__("0PFH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a05980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignItem_vue__ = __webpack_require__("X1q/");
function injectStyle (ssrContext) {
  __webpack_require__("SLLx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49a05980"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a05980_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("bh3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5vho":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6HXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postLogin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function postLogin(username, password) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post',
    url: 'login',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    data: {
      username: username,
      password: password,
      grant_type: 'password',
      client_secret: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_secret,
      client_id: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_id
    }
  });
}

/***/ }),

/***/ "7ZB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CampaignItem__ = __webpack_require__("5PKj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoData_vue__ = __webpack_require__("sqAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Error_vue__ = __webpack_require__("0J+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Campaigns',
  components: {
    campaignItem: __WEBPACK_IMPORTED_MODULE_0__CampaignItem__["a" /* default */],
    NoData: __WEBPACK_IMPORTED_MODULE_1__NoData_vue__["a" /* default */],
    Error: __WEBPACK_IMPORTED_MODULE_2__common_Error_vue__["a" /* default */]
  },
  data: function data() {
    return {
      campaigns: [],
      loading: false,
      error: false,
      hasData: true,
      page: 1,
      last_page: 1
    };
  },
  created: function created() {
    this.getCampaignsList();
  },

  methods: {
    getCampaignsList: function getCampaignsList() {
      var self = this;
      self.loading = true;
      self.$Progress.set(25);
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getCampaigns({ 'page': self.page }).then(function (r) {
        self.campaigns = r.data.data;
        self.$Progress.finish();
        self.loading = false;
        self.hasData = r.data.data.length > 0;
        self.last_page = r.data.meta.last_page;
      }).catch(function (e) {
        self.loading = false;
        self.$Progress.fail();
        self.error = e.response.data.error;
      });
    },
    nextPage: function nextPage() {
      if (this.page < this.last_page) {
        this.page += 1;
      }
    },
    prevPage: function prevPage() {
      if (this.page > 1) {
        this.page -= 1;
      }
    }
  },
  watch: {
    page: function page() {
      this.getCampaignsList();
    }
  }
});

/***/ }),

/***/ "8kZq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',[_c('div',{staticClass:"brand",on:{"click":_vm.toggleMenu}},[(!_vm.bare)?_c('i',{staticClass:"fa fa-fw",class:_vm.menuIcon,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":"/static/img/folyo_logo_w.svg","alt":"Folyo"}})]),_vm._v(" "),(!_vm.bare)?_c('div',{staticClass:"user",on:{"click":function($event){_vm.userToggle = true},"mouseover":function($event){_vm.userToggle = true}}},[_c('i',{staticClass:"fa fa-fw fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.user.email))]),_vm._v(" "),_c('i',{staticClass:"fa fa-fw fa-caret-down",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),(_vm.userToggle)?_c('div',{staticClass:"user-expanded",on:{"click":function($event){_vm.userToggle = false},"mouseleave":function($event){_vm.userToggle = false}}},[_c('router-link',{directives:[{name:"t",rawName:"v-t",value:('topnav.settings'),expression:"'topnav.settings'"}],staticClass:"item",attrs:{"to":{ name: 'User'},"tag":"a"}}),_vm._v(" "),_c('router-link',{directives:[{name:"t",rawName:"v-t",value:('topnav.logout'),expression:"'topnav.logout'"}],staticClass:"item",attrs:{"to":{ name: 'Login'},"tag":"a"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Fgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCampaign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getCampaign(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'get',
    url: 'campaigns/' + id + '/live',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    }
  });
}

/***/ }),

/***/ "BNRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    drawHeatmap: function drawHeatmap(url) {
      var self = this;
      var map = self.$refs.mainMap.$mapObject;
      var heatmapArray = [0, 2, 3];

      if (self.heatmap) {
        self.heatmap.setMap(null);
      }

      if (heatmapArray.includes(self.campaign.status)) {
        self.heatmap = new window.google.maps.visualization.HeatmapLayer({
          map: map,
          gradient: ['rgba(239, 125, 0, 0)', 'rgba(239, 125, 0, 0)', 'rgba(239, 125, 0, 0)', 'rgba(239, 125, 0, 0)', 'rgba(239, 125, 0, 0.1)', 'rgba(239, 125, 0, 0.2)', 'rgba(239, 125, 0, 0.3)', 'rgba(239, 125, 0, 0.4)', 'rgba(239, 125, 0, 0.5)', 'rgba(239, 125, 0, 0.6)', 'rgba(239, 125, 0, 0.7)', 'rgba(239, 125, 0, 0.8)', 'rgba(239, 125, 0, 0.9)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          'rgba(239, 125, 0, 1)', '#f55f00', '#f17600', '#f36a00', '#f85400', '#fa4900', '#fd3e00', '#ff3300'
          // 'rgba(255,255,255,0)',
          // 'rgba(255,255,255,0)',
          // 'rgba(255,255,255,0)',
          // 'rgba(255,255,255,0)',
          // 'rgba(255,255,255,0)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'rgba(239, 125, 0, 1)',
          // 'red'
          ],
          radius: 100
        });
        self.loadHeatmapData(url);
      } else {
        self.$emit('heatmap');
      }
    },
    loadHeatmapData: function loadHeatmapData(url) {
      var self = this;
      if (url.length) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default()({
          method: 'get',
          url: url,
          headers: {
            'Accept': 'application/json'
          }
        }).catch(function () {
          return alert('Journey data error');
        }).then(function (r) {
          var items = [];
          for (var i = 0; i < r.data.features.length; i++) {
            var location = new window.google.maps.LatLng(r.data.features[i].geometry.coordinates[1], r.data.features[i].geometry.coordinates[0]);

            var weight = r.data.features[i].properties.weight < 3000 ? r.data.features[i].properties.weight : 3000;
            items.push({ location: location, weight: weight });
          }
          self.heatmap.setData(items);
          self.$emit('heatmap');
        });
      }
    }
  }
});

/***/ }),

/***/ "BWRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('gmap-map',{ref:"mainMap",attrs:{"center":_vm.center,"zoom":12,"options":{styles: _vm.gmapstyle}}}),_vm._v(" "),(_vm.addon_panel_show)?_c('cockpit-addon',{attrs:{"meta":_vm.addon_display.meta,"attachments":_vm.addon_display.attachments},on:{"closeAddon":function($event){_vm.addon_panel_show=false}}}):_vm._e(),_vm._v(" "),(_vm.campaign)?_c('cockpit-switch',{attrs:{"options":_vm.campaign.zones},model:{value:(_vm.zone_index),callback:function ($$v) {_vm.zone_index=$$v},expression:"zone_index"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BjI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__("JEZ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['campaigns', 'loading', 'value'],
  data: function data() {
    return {
      selector: false
    };
  },

  computed: {
    campaignSelectedName: function campaignSelectedName() {
      var self = this;
      if (self.campaigns.length) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(self.campaigns, function (o) {
          return o.id === self.value;
        }).name;
      } else {
        return '';
      }
    }
  },
  methods: {
    toggleSelector: function toggleSelector() {
      this.selector = !this.selector;
    },
    closeSelector: function closeSelector() {
      this.selector = false;
    },
    selectCampaign: function selectCampaign(id) {
      this.selector = false;
      this.$emit('input', id);
    },
    caret: function caret() {
      return {
        'fa-caret-up': this.selector,
        'fa-caret-down': !this.selector
      };
    }
  }
});

/***/ }),

/***/ "CgSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),

/***/ "DIWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("n4fh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194370c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("8kZq");
function injectStyle (ssrContext) {
  __webpack_require__("dyBn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-194370c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194370c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EBSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,attrs:{"title":_vm.title || _vm.iso}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZL6":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'contacts': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.25 26.25',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M2.94 8.75H0V2.94A2.84 2.84 0 0 1 .85.85 2.84 2.84 0 0 1 2.94 0h5.81v2.94H2.94zm0 14.56h5.81v2.94H2.94a2.83 2.83 0 0 1-2.09-.85A2.83 2.83 0 0 1 0 23.31V17.5h2.94zM17.23 9a5.56 5.56 0 0 1 1.64 4.1 5.61 5.61 0 0 1-5.74 5.74 5.61 5.61 0 0 1-5.74-5.74A5.56 5.56 0 0 1 9 9a5.78 5.78 0 0 1 8.2 0zm-2.05 6.15a2.78 2.78 0 0 0 .82-2.02 2.8 2.8 0 0 0-2.87-2.87 2.8 2.8 0 0 0-2.87 2.87 2.78 2.78 0 0 0 .82 2.05 3 3 0 0 0 2.05.89 3 3 0 0 0 2.05-.89zM25.4.85a2.84 2.84 0 0 1 .85 2.08v5.82h-2.94V2.94H17.5V0h5.81a2.84 2.84 0 0 1 2.09.85zM23.31 17.5h2.94v5.81a2.92 2.92 0 0 1-2.94 2.94H17.5v-2.94h5.81z" id="Ebene_1" data-name="Ebene 1"/></g>'
  }
});

/***/ }),

/***/ "EfUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("INip");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc01e05e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("sF8m");
function injectStyle (ssrContext) {
  __webpack_require__("SqDC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc01e05e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc01e05e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EzpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flags"},[_c('div',{staticClass:"flag",class:{'active': _vm.lang == 'de-DE'},on:{"click":function($event){return _vm.langSwitch('de-DE')}}},[_c('flag',{attrs:{"iso":"de"}})],1),_vm._v(" "),_c('div',{staticClass:"flag",class:{'active': _vm.lang == 'en-GB'},on:{"click":function($event){return _vm.langSwitch('en-GB')}}},[_c('flag',{attrs:{"iso":"gb"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fg7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"error"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"text-transform":"capitalize"}},[_c('router-link',{attrs:{"to":{name:'Terms'},"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.$t('login.terms'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FpMa":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'money': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.25 17.5',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M0 0h26.25v17.5H0zm5.81 2.94a2.8 2.8 0 0 1-2.87 2.87v5.88a2.8 2.8 0 0 1 2.87 2.87h14.63a2.8 2.8 0 0 1 2.87-2.87V5.81a2.8 2.8 0 0 1-2.87-2.87zm7.31 1.44a4.42 4.42 0 0 1 3.08 1.3 4.17 4.17 0 0 1 1.23 3.08 4.21 4.21 0 0 1-4.31 4.31 4.21 4.21 0 0 1-4.3-4.32A4.17 4.17 0 0 1 10 5.67a4.42 4.42 0 0 1 3.13-1.29z" id="Ebene_1" data-name="Ebene 1"/></g>'
  }
});

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "GBpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"header"},[_c('b',[_vm._v(_vm._s(_vm.$t('login.password_reset.heading')))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',{staticClass:"helper"},[_vm._v(_vm._s(_vm.$t('login.password_reset.sent_info')))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(this.$route.query.email))])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('router-link',{attrs:{"to":{ name: 'Login'},"tag":"a"}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('login.back')))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gp5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        email: '',
        reset_url: window.location.origin + '/#/password/reset'
      }
    };
  },
  mounted: function mounted() {
    this.$Progress.finish();
  },

  methods: {
    resetRequest: function resetRequest() {
      var self = this;
      self.$Progress.set(25);

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].postResetRequest(self.form).then(function () {
        self.$Progress.finish();
        self.$router.push({ path: '/password/sent', query: { email: self.form.email } });
      }).catch(function () {
        alert('Something went wrong');
        self.$Progress.finish();
      });
    }
  }
});

/***/ }),

/***/ "H5+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addon-info"},[_c('h3',{staticClass:"header"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),_c('span',{staticClass:"pull-right",on:{"click":_vm.close}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.meta),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right"},[_c('b',[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._v("\n      "+_vm._s(item.value)+"\n    ")])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"img-block"},_vm._l((_vm.attachments),function(item,index){return _c('a',{key:index,staticClass:"thumbnail",attrs:{"href":item.url,"target":"_blank"}},[_c('img',{attrs:{"src":item.url,"width":"90px"}})])}),0)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HMh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_addon_js__ = __webpack_require__("jSVv");


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addons: [],
      addon_display: {
        meta: [],
        attachments: []
      }
    };
  },

  methods: {
    drawAddons: function drawAddons() {
      var self = this;

      self.addonsloading = true;

      if (self.addons.length) {
        self.clearMarkers();
      }

      for (var i = 0; i < self.campaign.addons.length; i++) {
        var addon = self.drawAddon(self.campaign.addons[i]);
        addon.set('meta', self.campaign.addons[i].meta);
        addon.set('attachments', self.campaign.addons[i].media);
        self.addons.push(addon);
      }
    },
    drawAddon: function drawAddon(addon) {
      var self = this;
      var map = self.$refs.mainMap.$mapObject;
      var icon = this.getAddonMarker(addon.rotation);

      var a = new window.google.maps.Marker({
        map: map,
        position: addon.coords,
        icon: icon
      });

      a.addListener('click', function (event) {
        self.addon_display.meta = this.get('meta');
        self.addon_display.attachments = this.get('attachments');
        self.addon_panel_show = true;
      });
      return a;
    },
    getAddonMarker: function getAddonMarker(rotation) {
      return {
        path: __WEBPACK_IMPORTED_MODULE_0__mixins_addon_js__["a" /* default */],
        fillColor: '#ef7d00',
        fillOpacity: 1,
        scale: 0.4,
        strokeWeight: 0,
        anchor: new window.google.maps.Point(12, 0),
        rotation: rotation
      };
    },
    clearMarkers: function clearMarkers() {
      var self = this;
      while (self.addons.length) {
        var addons = self.addons.shift();
        addons.setMap(null);
      }
    }
  }
});

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "INip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Profile__ = __webpack_require__("0Vif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Flags__ = __webpack_require__("gwcQ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Profile: __WEBPACK_IMPORTED_MODULE_2__Profile__["a" /* default */], Flags: __WEBPACK_IMPORTED_MODULE_3__Flags__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['toggleMenu']), {
    sidebarClicked: function sidebarClicked(e) {
      if (window.innerWidth < 768) {
        this.toggleMenu();
      }
    }
  })
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_js__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations_js__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__ = __webpack_require__("424j");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  state: __WEBPACK_IMPORTED_MODULE_2__state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations_js__["a" /* default */],
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_5_vuex_persistedstate__["a" /* default */])()]
}));

/***/ }),

/***/ "J8Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_car_js__ = __webpack_require__("pl7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__("JEZ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    drawCars: function drawCars() {
      var self = this;
      self.removeCars();

      if (self.repeater) {
        clearInterval(self.repeater);
        self.repeater = null;
      }

      if (self.shouldDrawLiveCars()) {
        self.getCars();
        self.repeater = setInterval(function () {
          self.updateCars();
        }, self.update_interval);
      } else {
        clearInterval(self.repeater);
      }
    },
    shouldDrawLiveCars: function shouldDrawLiveCars() {
      var self = this;
      var liveCarsArray = [2];
      return liveCarsArray.includes(self.campaign.status);
    },
    getCars: function getCars() {
      var self = this;

      self.carsLoading = true;

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCampaignLive(self.campaign.id).catch(function () {
        return alert('Cars data error');
      }).then(function (r) {
        var cars = r.data.data;
        for (var i = 0; i < cars.length; i++) {
          var car = self.drawCar(cars[i]);
          self.cars.push(car);
        }
        self.carsLoading = false;
      });
    },
    drawCar: function drawCar(car) {
      var self = this;
      var markerIcon = this.getMarker(car.rotation);
      var map = self.$refs.mainMap.$mapObject;
      var carMarker = new window.google.maps.Marker({
        map: map,
        position: { lat: car.latitude, lng: car.longitude },
        icon: markerIcon
      });
      carMarker.addListener('click', function () {
        console.log(car.id);
      });
      carMarker.set('id', car.id);
      carMarker.set('timer', null);
      return carMarker;
    },
    getMarker: function getMarker(rotation) {
      return {
        path: __WEBPACK_IMPORTED_MODULE_0__mixins_car_js__["a" /* default */],
        fillColor: '#01b1ec',
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 0,
        size: new window.google.maps.Size(24, 50),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(12, 25),
        rotation: rotation
      };
    },
    updateCars: function updateCars() {
      var self = this;

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCampaignLive(self.campaign.id).catch(function () {
        return alert('Cars data error');
      }).then(function (r) {
        var cars = r.data.data;
        for (var i = 0; i < cars.length; i++) {
          self.updateCar(cars[i]);
        }
      });
    },
    updateCar: function updateCar(car) {
      var id = car.id;
      var self = this;

      var storedCar = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(self.cars, function (o) {
        return o.id === id;
      });
      clearTimeout(storedCar.timer);
      var direction = {
        lng: car.longitude - storedCar.getPosition().lng(),
        lat: car.latitude - storedCar.getPosition().lat(),
        rotation: car.rotation - storedCar.icon.rotation
      };
      this.setSmoothPosition(0, storedCar, direction);
    },
    setSmoothPosition: function setSmoothPosition(i, start, direction) {
      var self = this;
      var newLocation = {
        lat: start.getPosition().lat() + 1 / self.smoother * direction.lat,
        lng: start.getPosition().lng() + 1 / self.smoother * direction.lng,
        rotation: start.icon.rotation + 1 / self.smoother * direction.rotation
      };
      start.setPosition(newLocation);
      start.setIcon(this.getMarker(newLocation.rotation));

      if (i < self.smoother - 1) {
        i++;
        start.timer = setTimeout(function () {
          self.setSmoothPosition(i, start, direction);
        }, self.update_interval / self.smoother);
      }
    },
    removeCars: function removeCars() {
      while (this.cars.length) {
        var car = this.cars.shift();
        car.setMap(null);
      }
    }
  }
});

/***/ }),

/***/ "JJT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        invitation_code: null,
        terms: false
      },
      errors: {}
    };
  },
  mounted: function mounted() {
    this.$Progress.finish();
  },

  methods: {
    register: function register() {
      var self = this;
      if (self.form.terms) {
        self.$Progress.set(25);

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].postRegister(self.form).then(function () {
          self.$Progress.set(50);
          var username = self.form.email;
          var password = self.form.password;
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].postLogin(username, password).then(function (d) {
            self.$store.commit('setToken', d.data.access_token);
            self.$Progress.set(75);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getUser().then(function (r) {
              self.$store.commit('setUser', r.data);
              self.$router.push('/cockpit');
              self.$Progress.finish();
            }).catch(function () {
              return self.$Progress.fail();
            });
          }).catch(function () {
            return self.$Progress.fail();
          });
        }).catch(function (e) {
          self.errors = e.response.data;
          self.$Progress.fail();
        });
      }
    }
  }
});

/***/ }),

/***/ "JiId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_DE_json__ = __webpack_require__("46x1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_DE_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_DE_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_GB_json__ = __webpack_require__("Pnoo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_GB_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_GB_json__);



/* harmony default export */ __webpack_exports__["a"] = ({ 'de-DE': __WEBPACK_IMPORTED_MODULE_0__de_DE_json___default.a, 'en-GB': __WEBPACK_IMPORTED_MODULE_1__en_GB_json___default.a });

/***/ }),

/***/ "LHuN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cockpit-selector"},[_c('div',{staticClass:"campaign-name-selector"},[_c('div',{staticClass:"selected",on:{"click":_vm.toggleSelector}},[_c('h3',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.campaignSelectedName)+"\n        "),(!_vm.loading)?_c('i',{staticClass:"pull-right fa",class:_vm.caret(),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-pulse"}):_vm._e()])]),_vm._v(" "),(_vm.selector)?_c('div',{staticClass:"selector"},[_c('ul',{on:{"mouseleave":_vm.closeSelector}},_vm._l((_vm.campaigns),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.selectCampaign(item.id)}}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}),0)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LbEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[(_vm.error)?_c('Error',{attrs:{"message":_vm.error}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form"},[_c('div',{staticClass:"header"},[_c('b',[_vm._v("\n        "+_vm._s(_vm.$t('login.header'))+"\n      ")]),_c('br'),_vm._v(" "+_vm._s(_vm.$t('login.subheader'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('login.email')))]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"text-input",attrs:{"type":"text","name":"email"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.password')))]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"text-input",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('span',[_c('router-link',{attrs:{"to":{ name: 'PassReset'},"tag":"a"}},[_vm._v("\n            "+_vm._s(_vm.$t('login.forgot'))+"\n          ")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){return _vm.handleLogin()}}},[_vm._v("\n          "+_vm._s(_vm.$t('login.login_btn'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("\n      "+_vm._s(_vm.$t('login.no_login'))+"\n\n      "),_c('router-link',{attrs:{"to":{ name: 'Register'},"tag":"a"}},[_vm._v("\n        "+_vm._s(_vm.$t('login.register_now'))+"\n      ")])],1)]),_vm._v(" "),_c('Flags')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LqzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      paragraphs: [1, 2, 3]
    };
  },
  created: function created() {
    this.$Progress.finish();
  }
});

/***/ }),

/***/ "Lyla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post',
    url: 'reset/request',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Accept': 'application/json'
    },
    data: data
  });
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507c520e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Y8MQ");
function injectStyle (ssrContext) {
  __webpack_require__("dNpN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507c520e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mg9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'options']
});

/***/ }),

/***/ "MqDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassResetSent_vue__ = __webpack_require__("jqUi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c424d244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassResetSent_vue__ = __webpack_require__("GBpJ");
function injectStyle (ssrContext) {
  __webpack_require__("h7TK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c424d244"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassResetSent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c424d244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassResetSent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NEq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: null
    };
  },
  created: function created() {
    this.$Progress.finish();
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (this.emailMatches()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(this.email).then(function (r) {
          localStorage.removeItem('vuex');
          _this.$router.push({ name: 'Login' });
        });
      } else {
        alert('Email doesn\'t match your user account.');
      }
    },
    emailMatches: function emailMatches() {
      return this.email === this.$store.state.user.email;
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_flag_icon__ = __webpack_require__("StEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang__ = __webpack_require__("cEaa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_svgicon__ = __webpack_require__("0QuU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_progressBarOptions__ = __webpack_require__("kWs6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_googlemapsOptions__ = __webpack_require__("mYTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_webpack__ = __webpack_require__("iGtm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_webpack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_font_awesome_webpack__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = "production" === 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_flag_icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_svgicon__);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_progressbar___default.a, __WEBPACK_IMPORTED_MODULE_9__mixins_progressBarOptions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, __WEBPACK_IMPORTED_MODULE_10__mixins_googlemapsOptions__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setApiBase', "https://services.getfolyo.com/api/v2");
__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setApiSecret', 'NrUgc6OQ2itfmx7hrLMLh98GC4yKQfYbDzwXYT1K');
__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('setApiID', 1);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_6__lang__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  created: function created() {
    this.$Progress.start();
  }
});

/***/ }),

/***/ "NZOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icons__);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['lang'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['switchLang']), {
    langSwitch: function langSwitch(lang) {
      this.$i18n.locale = lang;
      this.switchLang(lang);
    }
  })
});

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OA3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('h3',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('topnav.settings'))+"\n  ")]),_vm._v(" "),_c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("\n      "+_vm._s(_vm.$t('loading'))+"...\n    ")]):(_vm.error)?_c('div',[_c('Error',{attrs:{"message":_vm.error}})],1):_c('div',{staticClass:"form"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.email')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"email","disabled":"true"},domProps:{"value":_vm.user.email}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.password_repeat')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password_confirmation),expression:"password.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation"},domProps:{"value":(_vm.password.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password_confirmation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.registered_on')))]),_vm._v(" "),(_vm.user.user_since)?_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(new Date(_vm.user.user_since).toLocaleDateString(_vm.lang, {timeZone: 'Europe/Vienna'})))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('login.teams')))]),_vm._v(" "),_c('p',{staticClass:"form-control-static"},_vm._l((_vm.user.teams),function(team,index){return _c('span',{key:index,staticClass:"label label-danger teams"},[_vm._v(_vm._s(team))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('language')))]),_vm._v(" "),_c('Flags')],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"text-transform":"capitalize"}},[_c('router-link',{attrs:{"to":{name:'Terms'},"target":"_blank"}},[_vm._v("\n          "+_vm._s(_vm.$t('login.terms'))+"\n        ")])],1),_vm._v(" "),_c('button',{staticClass:"btn submit",on:{"click":_vm.update}},[_vm._v(_vm._s(_vm.$t('login.update')))]),_vm._v(" "),_c('button',{staticClass:"btn submit red",on:{"click":function($event){return _vm.$router.push({name:'UserDelete'})}}},[_vm._v(_vm._s(_vm.$t('login.delete')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OYm0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OlBK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PmVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaign_vue__ = __webpack_require__("cF05");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b706f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaign_vue__ = __webpack_require__("iJSS");
function injectStyle (ssrContext) {
  __webpack_require__("zIk5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86b706f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b706f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pnoo":
/***/ (function(module, exports) {

module.exports = {"campaigns":{"action":"Action","addons":{"carmob":{"desc":"Park at a desired high-frequency location in the city. Activate via a direct message to the driver.","title":"Carmob"},"incar":{"desc":"Dispenser, Audio, Video, etc. Turn a passenger experience into a brand experience.","title":"In-Car Branding"},"layout":{"desc":"Leave the effort of turning your corporate identity in to a suitable car branding to Folyo.","title":"Layout by Folyo"},"retargeting":{"desc":"Notifications on the phones of passing by pedestrians made simple. Speak to your audience twice.","title":"Re-Targeting"},"title":"Add-Ons"},"budget":"Budget","budget_spent":"Costs so far","city":"City","created":"Created","created_by":"Created by","created_on":"Created on","cust_detail":"Customer detail","duration":"Duration","fleet":"Fleet","header":"Campaign | Campaigns","impressions":"Impressions","impressions_ttl":"Impressions (total)","impressions_zone":"Impressions (in Zone)","location":"Location & Time","menu":{"details":"Campaign details"},"name":"Campaign name","progress":"Progress","status":"Status","status_label":"Campaign status","statuses":{"0":"Draft ","1":"In preparation (Folyo) ","2":"On the Road ","3":"Rolled out "},"timezone":"Time window","vehicles":"Vehicles","zone":"Zone"},"delete":{"action":"To proceed, please confirm the email associated with this account.","btn":{"cancel":"CANCEL","delete":"DELETE"},"head":"Delete your account?","subhead":"You are about to request the deletion of your account. Please note that it might take up to 48 hours for the request to be fulfilled during which time your account will no longer be accessible.","warning":"Once deleted, the account data cannot be recovered."},"language":"Language","loading":"Loading","login":{"back":"Back to login","click_here":"click here.","delete":"Delete account","driver_dash":"For Drivers Dashboard,","email":"E-mail","forgot":"Forgot password?","header":"Brands & Advertisers","invitation_code":"Invitation code (optional)","login_btn":"LOGIN","name":"Name","no_login":"Don't have login yet?","password":"Password","password_repeat":"Password confirm","password_reset":{"heading":"Password reset","info":"Please enter your registered email address. We will send you a reset link.","sent_info":"Please check your mailbox. We have sent you a reset link to the email address below.","set_new":"Please set a new password"},"register_now":"Register now","registered_on":"Registered on","registration":"Registration","registration_check":"Please check your mailbox. We have sent a confirmation email to the email address below.","subheader":"Login","teams":"Teams","terms":"the terms of service","understood":"I have read and understood {0}.","update":"Update"},"noshow":"Nothing to show","noshowsub":"You have no data to display","sidebar":{"campaigns":"Campaigns","cockpit":"Cockpit"},"terms":{"contact":"Contact","headline":"Terms of use","p1":"A visit to our website can result in the storage on our server of information about the access (date, time, page accessed). This does not represent any analysis of personal data (e.g., name, address or e-mail address).","p2":"If personal data are collected, this only occurs – to the extent possible – with the prior consent of the user of the website. Any forwarding of the data to third parties without the express consent of the user shall not take place.","p3":"We would like to expressly point out that the transmission of data via the Internet (e.g., by e-mail) can offer security vulnerabilities. It is therefore impossible to safeguard the data completely against access by third parties. We cannot assume any liability for damages arising as a result of such security vulnerabilities.","p4":"The use by third parties of all published contact details for the purpose of advertising is expressly excluded. We reserve the right to take legal steps in the case of the unsolicited sending of advertising information; e.g., by means of spam mail.","provider":"Provider"},"topnav":{"logout":"Logout","settings":"Settings"}}

/***/ }),

/***/ "Q7M0":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
__webpack_require__("j7Eg");
__webpack_require__("oWLk");
__webpack_require__("TkRS");
__webpack_require__("EZL6");
__webpack_require__("wtIQ");
__webpack_require__("FpMa");

/***/ }),

/***/ "QOuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3BI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCampaign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getCampaign(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'get',
    url: 'campaigns/' + id,
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    }
  });
}

/***/ }),

/***/ "RCb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ('gz' in _vm.options[_vm.value])?_c('div',{staticClass:"switch"},[_c('div',{staticClass:"label item"},[_vm._v("\n        "+_vm._s(_vm.options[_vm.value].gz.label)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"selector"},_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.$emit('input', index)}}},[_vm._v("\n          "+_vm._s(item.gz.label)+"\n        ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RKI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'elementType': 'geometry',
  'stylers': [{
    'color': '#f5f5f5'
  }]
}, {
  'elementType': 'labels.icon',
  'stylers': [{
    'visibility': 'off'
  }]
}, {
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#616161'
  }]
}, {
  'elementType': 'labels.text.stroke',
  'stylers': [{
    'color': '#f5f5f5'
  }]
}, {
  'featureType': 'administrative.land_parcel',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#bdbdbd'
  }]
}, {
  'featureType': 'poi',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#eeeeee'
  }]
}, {
  'featureType': 'poi',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#757575'
  }]
}, {
  'featureType': 'poi.park',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#e5e5e5'
  }]
}, {
  'featureType': 'poi.park',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#9e9e9e'
  }]
}, {
  'featureType': 'road',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#ffffff'
  }]
}, {
  'featureType': 'road.arterial',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#757575'
  }]
}, {
  'featureType': 'road.highway',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#dadada'
  }]
}, {
  'featureType': 'road.highway',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#616161'
  }]
}, {
  'featureType': 'road.local',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#9e9e9e'
  }]
}, {
  'featureType': 'transit.line',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#e5e5e5'
  }]
}, {
  'featureType': 'transit.station',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#eeeeee'
  }]
}, {
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': [{
    'color': '#c9c9c9'
  }]
}, {
  'featureType': 'water',
  'elementType': 'labels.text.fill',
  'stylers': [{
    'color': '#9e9e9e'
  }]
}]);

/***/ }),

/***/ "Rp40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__("LqzL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1f13da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__("Sdui");
function injectStyle (ssrContext) {
  __webpack_require__("qbbA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1f13da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SLLx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sdui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.$t('terms.headline'))+"\n  ")]),_vm._v(" "),_vm._l((_vm.paragraphs),function(i){return _c('p',{key:i},[_vm._v("\n    "+_vm._s(_vm.$t(("terms.p" + i)))+"\n  ")])}),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('terms.provider'))+":")]),_vm._v(" "),_c('br'),_vm._v("\n    Folyo GmbH "),_c('br'),_vm._v("\n    Edelhofgasse 21/3 "),_c('br'),_vm._v("\n    1180 Wien "),_c('br'),_vm._v("\n    Österreich "),_c('br')]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('terms.contact'))+":")]),_vm._v(" "),_c('br'),_vm._v("\n    +43 664 423 30 36 "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@getfolyo.com"}},[_vm._v("info@getfolyo.com")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SqDC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TkRS":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'cockpit': {
    width: 16,
    height: 16,
    viewBox: '0 0 29.12 25.29',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M14.56 0a15.08 15.08 0 0 1 7.25 1.91l-3.08 1.78a11.31 11.31 0 0 0-4.17-.75 11.39 11.39 0 0 0-8.27 3.38 11.73 11.73 0 0 0-3.42 8.24 12.62 12.62 0 0 0 1 4.58 11.36 11.36 0 0 0 2.46 3.69 1.26 1.26 0 0 1 .48 1 1.41 1.41 0 0 1-.44 1 1.41 1.41 0 0 1-1 .44 1.59 1.59 0 0 1-1.06-.41 14.56 14.56 0 0 1-3.11-4.61A14.33 14.33 0 0 1 0 14.56 14.53 14.53 0 0 1 14.56 0zm0 18.94a4.17 4.17 0 0 1-3.08-1.23 4.5 4.5 0 0 1-1.3-3.14 4.13 4.13 0 0 1 .62-2.22 4.42 4.42 0 0 1 1.57-1.54L26.52 2.6l-8.06 13.94a4.3 4.3 0 0 1-1.57 1.74 4.25 4.25 0 0 1-2.33.66zm14.56-4.37a14.33 14.33 0 0 1-1.12 5.7 14.58 14.58 0 0 1-3.11 4.61 1.59 1.59 0 0 1-1.06.41 1.3 1.3 0 0 1-1-.44 1.47 1.47 0 0 1-.41-1 1.35 1.35 0 0 1 .41-1 12.18 12.18 0 0 0 3.42-8.27 11.31 11.31 0 0 0-.82-4.24l1.78-3a15.08 15.08 0 0 1 1.91 7.22z" id="Ebene_1" data-name="Ebene 1"/></g>'
  }
});

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  userInitials: function userInitials(state) {
    var name = void 0;
    if (state.user.name) {
      name = state.user.name.split(' ');
    } else {
      name = ' ';
    }
    if (name.length > 1) {
      return name[0].charAt(0) + name[1].charAt(0);
    } else {
      return name[0].charAt(0);
    }
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.env.api_token != null;
    // return state.user.loggedIn
  }
});

/***/ }),

/***/ "VLQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vibr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VzzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['message']
});

/***/ }),

/***/ "WA5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login float"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"header"},[_c('b',[_vm._v(_vm._s(_vm.$t('login.registration'))+".")])]),_vm._v(" "),_c('div',{staticClass:"body blue"},[_c('div',{staticClass:"form-item",class:{'has-error': ('name' in _vm.errors)}},[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('login.name')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"text-input",attrs:{"type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(('name' in _vm.errors))?_c('div',_vm._l((_vm.errors.name),function(msg,index){return _c('small',{key:index,staticClass:"error-msg"},[_vm._v(_vm._s(msg))])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-item",class:{'has-error': ('email' in _vm.errors)}},[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('login.email')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"text-input",attrs:{"type":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),(('email' in _vm.errors))?_c('div',_vm._l((_vm.errors.email),function(msg,index){return _c('small',{key:index,staticClass:"error-msg"},[_vm._v(_vm._s(msg))])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-item",class:{'has-error': ('password' in _vm.errors)}},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.password')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"text-input",attrs:{"type":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),(('password' in _vm.errors))?_c('div',_vm._l((_vm.errors.password),function(msg,index){return _c('small',{key:index,staticClass:"error-msg"},[_vm._v(_vm._s(msg))])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.password_repeat')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],staticClass:"text-input",attrs:{"type":"password"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('login.invitation_code')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.invitation_code),expression:"form.invitation_code"}],staticClass:"text-input",attrs:{"type":"text","placeholder":"ABC123"},domProps:{"value":(_vm.form.invitation_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "invitation_code", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.terms),expression:"form.terms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.terms)?_vm._i(_vm.form.terms,null)>-1:(_vm.form.terms)},on:{"change":function($event){var $$a=_vm.form.terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "terms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "terms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "terms", $$c)}}}}),_vm._v(" "),_c('i18n',{attrs:{"path":"login.understood","tag":"span"}},[_c('router-link',{attrs:{"to":{ name: 'Terms'},"tag":"a","target":"_blank"}},[_vm._v("\n              "+_vm._s(_vm.$t('login.terms'))+"\n            ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('button',{staticClass:"btn btn-block",on:{"click":_vm.register}},[_vm._v(_vm._s(_vm.$t('login.register_now')))])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_c('router-link',{attrs:{"to":{ name: 'Login'},"tag":"a"}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('login.back'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WJFO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WhbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDelete_vue__ = __webpack_require__("NEq/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b17b1b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDelete_vue__ = __webpack_require__("eWWO");
function injectStyle (ssrContext) {
  __webpack_require__("WJFO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b17b1b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b17b1b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X+f0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X1q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaigns-item"},[_c('div',{staticClass:"hidden-xs campaign-item-desktop"},[_c('div',{staticClass:"item flex-2 center-left"},[_vm._v("\n      "+_vm._s(_vm.campaign.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item flex-2 center-right"},[_vm._v("\n      "+_vm._s(_vm.statusLabel)+"\n      "),_c('i',{staticClass:"fa fa-circle fa-fw",class:_vm.statusClass,attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"item flex-2 text-right"},[_vm._v("\n      "+_vm._s(_vm.durationLabel)),_c('br'),_vm._v("\n      ("+_vm._s(_vm.durationHuman)+")\n    ")]),_vm._v(" "),_c('div',{staticClass:"item center-right"},[_vm._v("\n      "+_vm._s(_vm.campaign.cars)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item center-right"},[_vm._v("\n      "+_vm._s(_vm.campaign.impressions['In zone'].toLocaleString(_vm.lang))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item center-right"},[_vm._v("\n      "+_vm._s(_vm.createdDate.toLocaleDateString(_vm.lang))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"item flex-2 center-right"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({width:_vm.progress+'%'})})])]),_vm._v(" "),(!_vm.menu)?_c('div',{staticClass:"item center-right",on:{"click":_vm.dropdown}},[_c('i',{staticClass:"fa fa-ellipsis-v",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.menu)?_c('div',{staticClass:"item",on:{"mouseleave":_vm.hide}},[_c('ul',{staticClass:"dropdown"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Campaign', params: {campaignID: _vm.campaign.id} },"tag":"a"}},[_vm._v("\n            "+_vm._s(_vm.$t('campaigns.menu.details'))+"\n          ")])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"visible-xs-block campaign-item-mobile"},[_c('h4',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.campaign.name)+"\n        "),_c('span',{staticClass:"pull-right",on:{"click":_vm.dropdown}},[_c('i',{staticClass:"fa fa-ellipsis-v",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),(_vm.menu)?_c('ul',{staticClass:"dropdown",on:{"mouseleave":_vm.hide}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Campaign', params: {campaignID: _vm.campaign.id} },"tag":"a"}},[_vm._v("\n                "+_vm._s(_vm.$t('campaigns.menu.details'))+"\n              ")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.status'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('i',{staticClass:"fa fa-circle fa-fw",class:_vm.statusClass,attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.statusLabel)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.duration'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._v("\n        "+_vm._s(_vm.durationLabel)),_c('br'),_vm._v("("+_vm._s(_vm.durationHuman)+")\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.vehicles'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._v("\n        "+_vm._s(_vm.campaign.cars)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.impressions'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._v("\n        "+_vm._s(_vm.campaign.impressions['In zone'].toLocaleString(_vm.lang))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.created'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_vm._v("\n        "+_vm._s(_vm.createdDate.toLocaleDateString(_vm.lang))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 text-right bold"},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.progress'))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 center-right"},[_vm._v("\n        "+_vm._s(_vm.progress)+"%\n      ")])]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({width:_vm.progress+'%'})})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y8MQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-progress-bar'),_vm._v(" "),_c('Navbar',{attrs:{"bare":_vm.showBare}}),_vm._v(" "),_c('div',{staticClass:"container-xl"},[(!_vm.showBare)?_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.env.menu)?_c('Sidebar'):_vm._e()],1):_vm._e(),_vm._v(" "),_c('main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YGiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getUser(username, password) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'get',
    url: 'user',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    }
  });
}

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("bGai");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  redirect: '/cockpit'
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["d" /* Login */],
  meta: { requiresAuth: false }
}, {
  path: '/terms',
  name: 'Terms',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["i" /* Terms */],
  meta: { requiresAuth: false }
}, {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["h" /* Register */],
  meta: { requiresAuth: false }
}, {
  path: '/password/reset',
  name: 'PassReset',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["e" /* PassReset */],
  meta: { requiresAuth: false }
}, {
  path: '/password/reset/:token/:email',
  name: 'PasswordChange',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["g" /* PasswordChange */],
  meta: { requiresAuth: false }
}, {
  path: '/password/sent',
  name: 'PassResetSent',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["f" /* PassResetSent */],
  meta: { requiresAuth: false }
}, {
  path: '/cockpit',
  name: 'Cockpit',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["c" /* Cockpit */],
  meta: { requiresAuth: true }
}, {
  path: '/campaigns',
  name: 'Campaigns',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["b" /* Campaigns */],
  meta: { requiresAuth: true }
}, {
  path: '/campaigns/:campaignID',
  name: 'Campaign',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["a" /* Campaign */],
  meta: { requiresAuth: true }
}, {
  path: '/user',
  name: 'User',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["j" /* User */],
  meta: { requiresAuth: true }
}, {
  path: '/user/delete',
  name: 'UserDelete',
  component: __WEBPACK_IMPORTED_MODULE_3__components__["k" /* UserDelete */],
  meta: { requiresAuth: true }
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yy+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['user']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['userInitials']))
});

/***/ }),

/***/ "Z4vB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZGSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile",on:{"click":function($event){return _vm.$router.push({name:'User'})}}},[_c('div',{staticClass:"initials"},[_vm._v("\n    "+_vm._s(_vm.userInitials)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.user.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zcs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordChange_vue__ = __webpack_require__("h+9L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14281b94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordChange_vue__ = __webpack_require__("jHNJ");
function injectStyle (ssrContext) {
  __webpack_require__("+NmB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14281b94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14281b94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordChange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Campaign_vue__ = __webpack_require__("PmVw");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Campaign_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Campaigns_vue__ = __webpack_require__("t7P8");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Campaigns_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cockpit_vue__ = __webpack_require__("bvKC");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Cockpit_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CockpitSelector_vue__ = __webpack_require__("trxE");
/* unused harmony reexport CockpitSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CockpitSwitch_vue__ = __webpack_require__("3ujs");
/* unused harmony reexport CockpitSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CockpitHeader_vue__ = __webpack_require__("3Ybh");
/* unused harmony reexport CockpitHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CockpitMap_vue__ = __webpack_require__("3gbg");
/* unused harmony reexport CockpitMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Login_vue__ = __webpack_require__("xJsL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Login_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PassReset_vue__ = __webpack_require__("xSQc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__PassReset_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PassResetSent_vue__ = __webpack_require__("MqDF");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__PassResetSent_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PasswordChange_vue__ = __webpack_require__("Zcs0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__PasswordChange_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Register_vue__ = __webpack_require__("dIqY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__Register_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__User_vue__ = __webpack_require__("jyJz");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_12__User_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UserDelete_vue__ = __webpack_require__("WhbO");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_13__UserDelete_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Terms_vue__ = __webpack_require__("Rp40");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_14__Terms_vue__["a"]; });
















/***/ }),

/***/ "bh3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bt/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cockpit"},[(_vm.loading)?_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('loading'))+"...\n  ")]):(_vm.error)?_c('p',[_c('Error',{attrs:{"message":_vm.error}})],1):_c('div',[(!_vm.hasData)?_c('NoData'):_vm._e(),_vm._v(" "),(_vm.campaign_id)?_c('CockpitSelector',{attrs:{"campaigns":_vm.campaignsList,"loading":_vm.mapLoading},model:{value:(_vm.campaign_id),callback:function ($$v) {_vm.campaign_id=$$v},expression:"campaign_id"}}):_vm._e(),_vm._v(" "),(_vm.campaign_id)?_c('CockpitHeader',{attrs:{"campaign":_vm.selectedCampaign}}):_vm._e(),_vm._v(" "),(_vm.campaign_id)?_c('CockpitMap',{attrs:{"campaign":_vm.selectedCampaign},on:{"heatmap":function($event){_vm.mapLoading = false}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bvKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cockpit_vue__ = __webpack_require__("2k+9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74985086_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cockpit_vue__ = __webpack_require__("bt/f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cockpit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74985086_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cockpit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cEaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__msg__ = __webpack_require__("JiId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var locale = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.lang;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale, messages: __WEBPACK_IMPORTED_MODULE_2__msg__["a" /* default */]
}));

/***/ }),

/***/ "cF05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoData_vue__ = __webpack_require__("sqAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_en_gb__ = __webpack_require__("hPuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_en_gb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_en_gb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_de__ = __webpack_require__("DOkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__icons__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Campaign',
  components: { NoData: __WEBPACK_IMPORTED_MODULE_1__NoData_vue__["a" /* default */] },
  data: function data() {
    return {
      campaign: null,
      fleet_pointer: 0,
      zone_pointer: 0,
      loading: true,
      hasData: true
    };
  },
  created: function created() {
    var self = this;
    var campaignID = self.$route.params.campaignID;
    self.loading = true;
    self.$Progress.set(25);
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getCampaign(campaignID).then(function (r) {
      self.campaign = r.data.data;
      self.loading = false;
      self.$Progress.finish();
      self.hasData = true;
    }).catch(function (e) {
      self.$Progress.fail();
      self.hasData = false;
      self.loading = false;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    cities: function cities() {
      if ('zones' in this.campaign) {
        var zones = this.campaign.zones;
        return zones.map(function (i) {
          return i.gz.label;
        }).join(', ');
      }
      return '';
    },
    durationHuman: function durationHuman() {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(this.lang);

      var start = new Date(this.campaign.start);
      var end = new Date(this.campaign.end);
      var diff = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start).from(__WEBPACK_IMPORTED_MODULE_2_moment___default()(end).add(1, 'days'), true);
      return diff;
    },
    durationLabel: function durationLabel() {
      var start = new Date(this.campaign.start);
      var end = new Date(this.campaign.end);
      var options = {
        timeZone: 'Europe/Vienna'
      };
      return start.toLocaleDateString(this.lang, options) + ' - ' + end.toLocaleDateString(this.lang, options);
    },
    statusLabel: function statusLabel() {
      return this.$t('campaigns.statuses.' + this.campaign.status);
    },
    statusClass: function statusClass() {
      return ['gray', 'orange', 'green', 'blue'][this.campaign.status];
    },
    foilDetail: function foilDetail() {
      return {
        'P': 'Partial',
        'F': 'Full'
      }[this.campaign.fleets[this.fleet].foiling];
    },
    zone: function zone() {
      return Math.abs(this.zone_pointer % this.campaign.zones.length);
    },
    fleet: function fleet() {
      return Math.abs(this.fleet_pointer % this.campaign.fleets.length);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['lang'])),
  methods: {
    addOnClass: function addOnClass(addon) {
      var self = this;
      return self.campaign.addons.includes(addon);
    }
  }
});

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "dIqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("JJT7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7d7bd2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("WA5y");
function injectStyle (ssrContext) {
  __webpack_require__("knXI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7d7bd2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7d7bd2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dNpN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dyBn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eWWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('h3',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t('delete.head'))+"\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('delete.subhead'))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"red"},[_vm._v("\n    "+_vm._s(_vm.$t('delete.warning'))+"\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('delete.action'))+"\n  ")]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn delete",on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.$t('delete.btn.delete'))+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"btn cancel",attrs:{"to":{name: 'User'}}},[_vm._v("\n      "+_vm._s(_vm.$t('delete.btn.cancel'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fFe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_gmapstyle_js__ = __webpack_require__("RKI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_drawHeatmap_js__ = __webpack_require__("BNRi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_drawCars_js__ = __webpack_require__("J8Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_drawAddons_js__ = __webpack_require__("HMh6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CockpitAddon__ = __webpack_require__("nxXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CockpitSwitch__ = __webpack_require__("3ujs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CockpitMap',
  props: ['campaign'],
  components: {
    CockpitAddon: __WEBPACK_IMPORTED_MODULE_4__CockpitAddon__["a" /* default */],
    CockpitSwitch: __WEBPACK_IMPORTED_MODULE_5__CockpitSwitch__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_drawHeatmap_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_drawCars_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_drawAddons_js__["a" /* default */]],
  data: function data() {
    return {
      center: {
        lat: 48.2080586,
        lng: 16.3709961
      },
      heatmap: null,
      cars: [],
      addons: [],
      update_interval: 10000,
      smoother: 250,
      last_update: null,
      repeater: null,
      addon_panel_show: false,
      gmapstyle: __WEBPACK_IMPORTED_MODULE_0__mixins_gmapstyle_js__["a" /* default */],
      zone_index: 0
    };
  },
  mounted: function mounted() {
    this.draw();
  },

  watch: {
    campaign: function campaign() {
      this.zone_index = 0;
      this.draw();
    },
    zone_index: function zone_index() {
      this.panFrame();
    }
  },
  methods: {
    draw: function draw() {
      var self = this;
      self.$Progress.set(50);

      self.$refs.mainMap.$mapCreated.then(function () {
        // CARS
        if (self.campaign) {
          self.drawCars();

          self.panFrame();

          self.drawAddons();
        }

        // ADDONS
        // self.drawAddons()

        // FRAMES

        // if (self.campaign.zones) {
        // } else {
        // // HEATMAP
        //   self.drawHeatmap(self.campaign.heatmap)
        // }

        self.$Progress.finish();
      });
    },
    panFrame: function panFrame() {
      var self = this;
      var map = self.$refs.mainMap.$mapObject;
      var bounds = self.campaign.zones[self.zone_index].frame;
      map.fitBounds(bounds);
      self.drawFrame();
    },
    drawFrame: function drawFrame() {
      var self = this;
      var map = self.$refs.mainMap.$mapObject;
      var url = self.campaign.zones[self.zone_index].gz.json;

      map.data.forEach(function (i) {
        return map.data.remove(i);
      });
      map.data.loadGeoJson(url);
      map.data.setStyle({
        fillOpacity: '0',
        strokeColor: '#00b1eb'
      });

      var heatmapUrl = self.campaign.zones[self.zone_index].heatmap;
      self.drawHeatmap(heatmapUrl);
    }
  }
});

/***/ }),

/***/ "fHM9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fure":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqt1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flags_vue__ = __webpack_require__("NZOJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fe4c20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flags_vue__ = __webpack_require__("EzpO");
function injectStyle (ssrContext) {
  __webpack_require__("Z4vB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37fe4c20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37fe4c20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deleteAccount_js__ = __webpack_require__("0j7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getCampaign_js__ = __webpack_require__("R3BI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getCampaigns_js__ = __webpack_require__("u9M8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getCampaignLive_js__ = __webpack_require__("9NuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__postLogin_js__ = __webpack_require__("6HXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getUser_js__ = __webpack_require__("YGiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__postUser_js__ = __webpack_require__("/HT/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__postRegister_js__ = __webpack_require__("q9cR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__postResetRequest_js__ = __webpack_require__("Lyla");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postReset_js__ = __webpack_require__("znuL");











/* harmony default export */ __webpack_exports__["a"] = ({
  getCampaign: __WEBPACK_IMPORTED_MODULE_1__getCampaign_js__["a" /* default */],
  getCampaigns: __WEBPACK_IMPORTED_MODULE_2__getCampaigns_js__["a" /* default */],
  getCampaignLive: __WEBPACK_IMPORTED_MODULE_3__getCampaignLive_js__["a" /* default */],
  postLogin: __WEBPACK_IMPORTED_MODULE_4__postLogin_js__["a" /* default */],
  getUser: __WEBPACK_IMPORTED_MODULE_5__getUser_js__["a" /* default */],
  postUser: __WEBPACK_IMPORTED_MODULE_6__postUser_js__["a" /* default */],
  deleteAccount: __WEBPACK_IMPORTED_MODULE_0__deleteAccount_js__["a" /* default */],
  postRegister: __WEBPACK_IMPORTED_MODULE_7__postRegister_js__["a" /* default */],
  postResetRequest: __WEBPACK_IMPORTED_MODULE_8__postResetRequest_js__["a" /* default */],
  postReset: __WEBPACK_IMPORTED_MODULE_9__postReset_js__["a" /* default */]
});

/***/ }),

/***/ "h+9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        token: null,
        email: null,
        password: '',
        password_confirmation: ''
      }
    };
  },
  created: function created() {
    this.form.token = this.$route.params.token;
    this.form.email = this.$route.params.email;
  },
  mounted: function mounted() {
    this.$Progress.finish();
  },

  methods: {
    resetPass: function resetPass() {
      var _this = this;

      var self = this;
      this.$Progress.set(25);
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].postReset(self.form).then(function () {
        self.$router.push('/login');
        _this.$Progress.finish();
      }).catch(function () {
        _this.$Progress.fail();
        alert('Something went wrong.');
      });
    }
  }
});

/***/ }),

/***/ "h7TK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("\n    "+_vm._s(_vm.$t('loading'))+"...\n  ")]):_c('div',[(!_vm.hasData)?_c('NoData'):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"campaign-show"},[_c('div',{staticClass:"cockpit-header"},[_c('div',{staticClass:"gr"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"car","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.$tc('campaigns.header',1))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.campaign.name))])])]),_vm._v(" "),_c('div',{staticClass:"gr gr-2x"},[_c('div',{staticClass:"item spaced"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"contacts","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('campaigns.duration'))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.durationHuman))])]),_vm._v(" "),_c('div',{staticClass:"item spaced"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"eye","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('campaigns.city'))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.cities))])])]),_vm._v(" "),_c('div',{staticClass:"gr gr-2x"},[_c('div',{staticClass:"item spaced"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"money","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('campaigns.budget'))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.campaign.budget.toLocaleString(_vm.lang,{ style: 'currency', currency: 'EUR',maximumFractionDigits: 0,minimumFractionDigits: 0 })))])]),_vm._v(" "),_c('div',{staticClass:"item spaced"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"car","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('campaigns.vehicles'))+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.campaign.cars))])])])]),_vm._v(" "),_c('div',{staticClass:"campaign-status",class:_vm.statusClass},[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.status_label'))+": "+_vm._s(_vm.statusLabel)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"campaign-body-row"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"item-content"},[_c('label',[_vm._v(_vm._s(_vm.$tc('campaigns.header',1)))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.name')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(" "+_vm._s(_vm.campaign.name))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.cust_detail')))]),_vm._v(" "),_c('div',{staticClass:"item-value pre"},[_vm._v(_vm._s(_vm.campaign.customer_detail))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.created_on')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(" "+_vm._s(new Date(this.campaign.created).toLocaleDateString(_vm.lang,{timeZone: 'Europe/Vienna'})))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.created_by')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(" "+_vm._s(_vm.campaign.created_by))])])]),_vm._v(" "),_c('div',{staticClass:"item item-2x"},[_c('div',{staticClass:"subitem"},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"row"},[(_vm.campaign.fleets[_vm.fleet])?_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('campaigns.vehicles')))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.fleet')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.campaign.fleets[_vm.fleet]?_vm.campaign.fleets[_vm.fleet].class  :null))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.vehicles')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.campaign.fleets[_vm.fleet].cars)+"x "+_vm._s(_vm.foilDetail))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.campaign.fleets[_vm.fleet] ? _vm.campaign.fleets[_vm.fleet].class : null))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.campaign.fleets[_vm.fleet].detail))])]):_vm._e(),_vm._v(" "),(_vm.campaign.fleets[_vm.fleet])?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"fleet-preview"},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.fleet_pointer--}}}),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.campaign.fleets[_vm.fleet].cover_thumb,"height":"30px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.fleet_pointer++}}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"subitem"},[_c('div',{staticClass:"item-content"},[_c('label',[_vm._v(_vm._s(_vm.$t('campaigns.addons.title')))]),_vm._v(" "),_c('div',{staticClass:"addons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6",class:{'disabled': !_vm.campaign.meta || _vm.campaign.meta.carmob != 1 }},[_c('div',{staticClass:"item-label"},[_c('i',{staticClass:"fa fa-fw",class:{'fa-square': _vm.campaign.meta && _vm.campaign.meta.carmob == 1, 'fa fa-square-o': !_vm.campaign.meta || _vm.campaign.meta.carmob != 1},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('campaigns.addons.carmob.title')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.$t('campaigns.addons.carmob.desc')))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6",class:{'disabled': !_vm.campaign.meta || _vm.campaign.meta.retarget != 1 }},[_c('div',{staticClass:"item-label"},[_c('i',{staticClass:"fa fa-fw",class:{'fa-square':_vm.campaign.meta && _vm.campaign.meta.retarget == 1, 'fa fa-square-o': !_vm.campaign.meta || _vm.campaign.meta.retarget != 1},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('campaigns.addons.retargeting.title')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.$t('campaigns.addons.retargeting.desc')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6",class:{'disabled': !_vm.campaign.meta || _vm.campaign.meta.incar != 1}},[_c('div',{staticClass:"item-label"},[_c('i',{staticClass:"fa fa-fw",class:{'fa-square':_vm.campaign.meta && _vm.campaign.meta.incar == 1, 'fa fa-square-o': !_vm.campaign.meta || _vm.campaign.meta.incar != 1},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('campaigns.addons.incar.title')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.$t('campaigns.addons.incar.desc')))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6",class:{'disabled': !_vm.campaign.meta || _vm.campaign.meta.layout != 1}},[_c('div',{staticClass:"item-label"},[_c('i',{staticClass:"fa fa-fw",class:{'fa-square':_vm.campaign.meta && _vm.campaign.meta.layout == 1, 'fa fa-square-o': !_vm.campaign.meta || _vm.campaign.meta.layout != 1},attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('campaigns.addons.layout.title')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.$t('campaigns.addons.layout.desc')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"item  item-2x"},[(_vm.campaign.zones.length)?_c('div',{staticClass:"item-content"},[_c('label',[_vm._v(_vm._s(_vm.$t('campaigns.location')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.zone')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.campaign.zones.length? _vm.campaign.zones[_vm.zone].gz.label:''))]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.duration')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.durationLabel)),_c('br'),_vm._v("("+_vm._s(_vm.durationHuman)+")")]),_vm._v(" "),_c('div',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.$t('campaigns.timezone')))]),_vm._v(" "),_c('div',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.campaign.zones.length? _vm.campaign.zones[_vm.zone].tz.label: ''))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 zone-preview"},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.zone_pointer--}}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.campaign.zones.length? _vm.campaign.zones[_vm.zone].gz.thumb: '',"target":"_blank"}},[_c('img',{staticClass:"geozone img-responsive",attrs:{"src":_vm.campaign.zones.length? _vm.campaign.zones[_vm.zone].gz.thumb: ''}})]),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.zone_pointer++}}})])]),_vm._v(" "),_c('img',{staticClass:"img-responsive timezone",attrs:{"src":_vm.campaign.zones.length? _vm.campaign.zones[_vm.zone].tz.thumb:'',"alt":""}})]):_vm._e()])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j7Eg":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'campaign': {
    width: 16,
    height: 16,
    viewBox: '0 0 16.64 16.64',
    data: '<path pid="0" d="M16.17 8a1.7 1.7 0 0 1 0 2.34l-5.86 5.86a1.7 1.7 0 0 1-2.34 0L.47 8.67A1.59 1.59 0 0 1 0 7.5V1.64A1.6 1.6 0 0 1 1.64 0H7.5a1.59 1.59 0 0 1 1.17.47zM2.89 4.14a1.22 1.22 0 0 0 .9-.35 1.19 1.19 0 0 0 .35-.88 1.2 1.2 0 0 0-1.23-1.23 1.2 1.2 0 0 0-1.23 1.23 1.19 1.19 0 0 0 .32.88 1.17 1.17 0 0 0 .89.35zM9.14 15L15 9.14 7.89 2.07 2.07 7.89z"/>'
  }
});

/***/ }),

/***/ "jHNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"header"},[_c('b',[_vm._v(_vm._s(_vm.$t('login.password_reset.heading')))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',{staticClass:"helper"},[_vm._v("\n        "+_vm._s(_vm.$t('login.password_reset.set_new'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":""}},[_vm._v("\n          "+_vm._s(_vm.$t('login.password'))+"\n        ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"text-input",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":""}},[_vm._v("\n          "+_vm._s(_vm.$t('login.password_repeat'))+"\n        ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],staticClass:"text-input",attrs:{"type":"password","name":"password-confirm"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('button',{staticClass:"btn btn-block",on:{"click":_vm.resetPass}},[_vm._v(_vm._s(_vm.$t('login.update')))])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"/login"}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('login.back')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "jSVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('M59.9,10.1c6.6,6.6,9.9,14.8,10.1,24.8-1.4,14.2-7.2,28.3-17.5,42.3S36.4,98.7,35,99.8c-1.4-1.1-7.2-8.6-17.5-22.6S1.4,49.1,0,34.9c.2-10,3.5-18.3,10.1-24.8S24.9.2,34.9,0C45,.2,53.3,3.6,59.9,10.1Zm-16,33.8A12.13,12.13,0,0,0,47.4,35,12,12,0,0,0,35,22.6,12,12,0,0,0,22.6,35,12,12,0,0,0,35,47.4,12.13,12.13,0,0,0,43.9,43.9Z');

/***/ }),

/***/ "jqUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$Progress.finish();
  }
});

/***/ }),

/***/ "jyJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__("qgpy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d17c04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__("OA3q");
function injectStyle (ssrContext) {
  __webpack_require__("/0jp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61d17c04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d17c04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kWs6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  color: '#004563',
  failedColor: '#FF0000',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
});

/***/ }),

/***/ "knXI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  lang: 'en-GB',
  user: {
    name: null,
    email: null
  },
  env: {
    menu: true,
    api_base: null,
    api_token: null,
    api_secret: null,
    api_id: null
  }
});

/***/ }),

/***/ "mYTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  load: {
    key: 'AIzaSyACtDfWX6-_dN1d2dCnHe5G0OxfbblAil8',
    libraries: 'visualization',
    language: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.lang,
    region: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.lang
  }
});

/***/ }),

/***/ "n4fh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  props: ['bare'],
  data: function data() {
    return {
      userToggle: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['env', 'user']), {
    menuIcon: function menuIcon() {
      var self = this;
      return self.env.menu ? 'fa-bars' : 'fa-chevron-right';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['toggleMenu']))
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Flags__ = __webpack_require__("gwcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Error_vue__ = __webpack_require__("0J+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    Flags: __WEBPACK_IMPORTED_MODULE_0__common_Flags__["a" /* default */], Error: __WEBPACK_IMPORTED_MODULE_1__common_Error_vue__["a" /* default */]
  },
  data: function data() {
    return {
      username: '',
      password: '',
      error: false
    };
  },
  created: function created() {
    localStorage.removeItem('vuex');
    this.$Progress.finish();
  },

  methods: {
    handleLogin: function handleLogin() {
      var self = this;
      var username = self.username;
      var password = self.password;

      self.$Progress.set(25);

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].postLogin(username, password).then(function (d) {
        self.$store.commit('setToken', d.data.access_token);
        self.$Progress.set(50);

        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getUser().then(function (r) {
          self.$store.commit('setUser', r.data);
          self.redirect();
          self.$Progress.finish();
        }).catch(function (e) {
          self.$Progress.fail();
          self.error = e.response.data.error;
        });
      }).catch(function (e) {
        self.$Progress.fail();
        self.error = e.response.data.message;
      });
    },
    redirect: function redirect() {
      var self = this;
      var path = self.$route.query.redirect || null;

      if (path) {
        self.$router.push({
          path: path
        });
      } else {
        self.$router.push('/cockpit');
      }
    }
  }
});

/***/ }),

/***/ "nxXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitAddon_vue__ = __webpack_require__("+GB/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675418ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitAddon_vue__ = __webpack_require__("H5+G");
function injectStyle (ssrContext) {
  __webpack_require__("fure")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-675418ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitAddon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675418ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitAddon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWLk":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'car': {
    width: 16,
    height: 16,
    viewBox: '0 0 26.25 23.31',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M26.25 10.19v11.69a1.4 1.4 0 0 1-1.44 1.44h-1.5a1.4 1.4 0 0 1-1.44-1.44v-1.5H4.38v1.5a1.4 1.4 0 0 1-1.44 1.44h-1.5A1.4 1.4 0 0 1 0 21.88V10.19l3-8.75a2.56 2.56 0 0 1 .82-1A2.1 2.1 0 0 1 5.13 0h16a2.11 2.11 0 0 1 1.3.41 2.57 2.57 0 0 1 .82 1zm-2.94-1.44l-2.19-6.56h-16L2.94 8.75zM6.63 15.38a2.15 2.15 0 0 0-1.54-3.69 2.18 2.18 0 0 0-1.54 3.69 2.13 2.13 0 0 0 1.58.62 2 2 0 0 0 1.5-.62zm16.06 0a2.15 2.15 0 1 0-3.08 0 2 2 0 0 0 1.5.62 2.13 2.13 0 0 0 1.59-.62z" id="Ebene_1" data-name="Ebene 1"/></g>'
  }
});

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "pLvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaign)?_c('div',{staticClass:"cockpit-header"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"car","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('campaigns.vehicles')))])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.campaign.cars))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"contacts","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('campaigns.impressions_zone')))])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.campaign.impressions['In zone'].toLocaleString(_vm.lang)))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"eye","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.impressions_ttl'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.impressions.toLocaleString(_vm.lang)))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"a"},[_c('svgicon',{attrs:{"name":"money","color":"#00b1eb","scale":"1.5"}}),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('campaigns.budget_spent'))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"b"},[_vm._v(_vm._s(_vm.budget.toLocaleString(_vm.lang,{ style: 'currency', currency: 'EUR',maximumFractionDigits: 0,minimumFractionDigits: 0 })))])]),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){_vm.image_pointer++}}},[_c('img',{staticClass:"car-preview",attrs:{"src":_vm.campaign.fleets[_vm.image_index]?_vm.campaign.fleets[_vm.image_index].cover_thumb: null,"height":"50px"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pl7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('M22.373,14.537c0.052-2.53,0.1-4.568,0.1-6.42c0-3.493-1.222-5.456-2.374-6.52C18.947,0.731,15.048,0,11.999,0c-3.084,0-6.947,0.731-8.1,1.597c-1.152,1.064-2.372,3.027-2.372,6.52c0,1.853,0.047,3.89,0.099,6.42c-0.868,0.898-1.672,1.975-1.624,2.711c0.043,0.661,1.201,0.447,1.679,0.122c0.046,2.612,0.083,5.707,0.083,9.509c0,9.515-0.271,14.006-0.271,17.632c0,1,0.262,2.762,2.033,3.959C4.996,49.463,7.511,50,11.999,50c4.473,0,7.003-0.537,8.473-1.53c1.771-1.197,2.034-2.959,2.034-3.959c0-3.626-0.271-8.117-0.271-17.632c0-3.802,0.037-6.896,0.083-9.509c0.479,0.326,1.636,0.54,1.68-0.122C24.046,16.512,23.24,15.436,22.373,14.537 M18.032,2.428c0-0.366,0.308-0.798,0.645-0.765c0.678,0.066,1.221,0.865,1.897,1.83c0.678,0.965,1.22,3.593,1.187,3.892c-0.17,0.1-1.018-0.399-1.288-0.931c-0.271-0.532-1.118-1.331-1.83-2.163C17.932,3.459,18.032,2.794,18.032,2.428 M20.573,13.872c0.373,0.2,0.373,0.433,0.306,0.732s-0.948,5.755-1.017,6.054c-0.067,0.3,0.169,0.699-0.848,0.566c-1.015-0.133-5.085-0.332-7.016-0.333c-1.97,0-6.001,0.2-7.015,0.333c-1.017,0.133-0.779-0.266-0.847-0.566c-0.068-0.299-0.949-5.755-1.017-6.054s-0.068-0.532,0.305-0.732c1.32-0.731,5.997-1.33,8.574-1.331C14.54,12.542,19.253,13.141,20.573,13.872 M3.424,3.493c0.678-0.965,1.22-1.763,1.898-1.83C5.659,1.63,5.966,2.062,5.966,2.428s0.102,1.031-0.61,1.863c-0.712,0.832-1.56,1.63-1.831,2.163S2.408,7.485,2.238,7.385C2.205,7.085,2.747,4.458,3.424,3.493 M2.78,35.163C2.441,35.029,2.51,34.93,2.476,34.53c-0.034-0.398-0.203-16.633-0.203-16.633c0-0.333,0.406-0.399,0.61-0.1c0.094,0.139,1.017,3.892,1.017,8.916s-0.338,7.651-0.44,8.117C3.357,35.296,3.12,35.296,2.78,35.163M20.184,43.479c-0.608,0.332-3.915,1.855-8.185,1.862c-4.255-0.007-7.576-1.53-8.184-1.862c-0.61-0.333-0.789-0.766-0.687-1.197c0.102-0.433,0.775-3.959,0.877-4.491c0.102-0.532,0.354-0.632,0.896-0.499c0.541,0.133,4.254,0.827,7.098,0.831c2.847-0.004,6.558-0.698,7.098-0.831c0.543-0.133,0.795-0.033,0.896,0.499s0.776,4.059,0.878,4.491C20.973,42.714,20.793,43.146,20.184,43.479 M21.523,34.53c-0.034,0.399,0.034,0.499-0.306,0.633c-0.338,0.133-0.575,0.133-0.677-0.333S20.1,31.736,20.1,26.713s0.924-8.777,1.017-8.916c0.204-0.299,0.61-0.233,0.61,0.1C21.727,17.897,21.558,34.132,21.523,34.53');

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q9cR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postRegister;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function postRegister(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post',
    url: 'register',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Accept': 'application/json'
    },
    data: data
  });
}

/***/ }),

/***/ "qbbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qgpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Flags__ = __webpack_require__("gwcQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Error_vue__ = __webpack_require__("0J+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'User',
  components: {
    Flags: __WEBPACK_IMPORTED_MODULE_1__common_Flags__["a" /* default */], Error: __WEBPACK_IMPORTED_MODULE_2__common_Error_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      error: false,
      user: {
        name: '',
        email: null,
        teams: [],
        user_since: null
      },
      password: {
        password: '',
        password_confirmation: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.$Progress.start();
    this.$Progress.set(25);

    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getUser().then(function (r) {
      _this.user = r.data;
      _this.loading = false;
      _this.$Progress.finish();
    }).catch(function (e) {
      _this.loading = false;
      _this.$Progress.fail();
      _this.error = e.response.data.error;
    });
  },

  methods: {
    update: function update() {
      var self = this;
      var payload = {
        name: self.user.name
      };
      if (self.password.password.length) {
        payload.password = this.password.password;
        payload.password_confirmation = this.password.password_confirmation;
      }
      this.$Progress.start();
      this.$Progress.set(25);
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].postUser(payload).then(function () {
        return self.$Progress.finish();
      }).catch(function () {
        return self.$Progress.fail();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['env', 'lang']))
});

/***/ }),

/***/ "qlcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('loading'))+"...\n  ")]):(_vm.error)?_c('div',[_c('Error',{attrs:{"message":_vm.error}})],1):_c('div',[(!_vm.hasData)?_c('NoData'):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('h3',[_vm._v("\n      "+_vm._s(_vm.$tc('campaigns.header',2))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasData)?_c('div',{staticClass:"campaigns-container"},[_c('div',{staticClass:"campaigns"},[_c('div',{staticClass:"campaigns-header hidden-xs"},[_c('div',{staticClass:"header flex-2"},[_vm._v(_vm._s(_vm.$t('campaigns.name')))]),_vm._v(" "),_c('div',{staticClass:"header flex-2 text-right"},[_vm._v(_vm._s(_vm.$t('campaigns.status')))]),_vm._v(" "),_c('div',{staticClass:"header text-right flex-2"},[_vm._v(_vm._s(_vm.$t('campaigns.duration')))]),_vm._v(" "),_c('div',{staticClass:"header text-right"},[_vm._v(_vm._s(_vm.$t('campaigns.vehicles')))]),_vm._v(" "),_c('div',{staticClass:"header text-right"},[_vm._v(_vm._s(_vm.$t('campaigns.impressions')))]),_vm._v(" "),_c('div',{staticClass:"header text-right"},[_vm._v(_vm._s(_vm.$t('campaigns.created')))]),_vm._v(" "),_c('div',{staticClass:"header flex-2"},[_vm._v(_vm._s(_vm.$t('campaigns.progress')))]),_vm._v(" "),_c('div',{staticClass:"header text-right"},[_vm._v(_vm._s(_vm.$t('campaigns.action')))])]),_vm._v(" "),_vm._l((_vm.campaigns),function(campaign){return _c('campaignItem',{key:campaign.id,attrs:{"campaign":campaign}})}),_vm._v(" "),_c('div',{staticClass:"campaigns-footer"},[_c('div',[_c('div',{class:{'enabled': _vm.page > 1},on:{"click":function($event){return _vm.prevPage()}}},[_c('i',{staticClass:"fa fa-chevron-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{class:{'enabled': _vm.page < _vm.last_page},on:{"click":function($event){return _vm.nextPage()}}},[_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})])])])],2)]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sF8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('ul',[_c('Profile'),_vm._v(" "),_c('div',{on:{"click":_vm.sidebarClicked}},[_c('router-link',{attrs:{"tag":"a","to":"/campaigns"}},[_c('svgicon',{attrs:{"name":"campaign","color":"white","scale":"1.5"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('sidebar.campaigns')))])],1)],1),_vm._v(" "),_c('div',{on:{"click":_vm.sidebarClicked}},[_c('router-link',{attrs:{"tag":"a","to":"/cockpit"}},[_c('svgicon',{attrs:{"name":"cockpit","color":"white","scale":"1.5"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('sidebar.cockpit')))])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQf1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "scIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__ = __webpack_require__("CgSS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a3c30bea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Flag_vue__ = __webpack_require__("EBSI");
function injectStyle (ssrContext) {
  __webpack_require__("X+f0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a3c30bea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Flag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sqAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_534c28a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoData_vue__ = __webpack_require__("txUa");
function injectStyle (ssrContext) {
  __webpack_require__("+Bx8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-534c28a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_534c28a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t2fV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__("Q7M0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icons__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['campaign'],
  data: function data() {
    return {
      image_pointer: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    image_index: function image_index() {
      return this.image_pointer % this.campaign.fleets.length;
    },
    impressions: function impressions() {
      return this.campaign.impressions['In zone'] + this.campaign.impressions['Out zone'];
    },
    budget: function budget() {
      var campaign = this.campaign;
      if ('budget_sofar' in campaign) {
        return campaign.budget_sofar;
      }
      return campaign.budget;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['lang']))
});

/***/ }),

/***/ "t7P8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__ = __webpack_require__("7ZB1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535adaba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__ = __webpack_require__("qlcq");
function injectStyle (ssrContext) {
  __webpack_require__("VLQK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-535adaba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535adaba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "trxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitSelector_vue__ = __webpack_require__("BjI6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1775f168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitSelector_vue__ = __webpack_require__("LHuN");
function injectStyle (ssrContext) {
  __webpack_require__("OYm0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1775f168"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CockpitSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1775f168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CockpitSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$t('noshow'))+"\n  ")]),_vm._v(" "),_c('small',[_vm._v("\n      "+_vm._s(_vm.$t('noshowsub'))+".\n  ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9M8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCampaigns;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function getCampaigns() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'page': 1 };

  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'get',
    url: 'campaigns',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_token,
      'Accept': 'application/json'
    },
    params: params
  });
}

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toggleMenu: function toggleMenu(state) {
    state.env.menu = !state.env.menu;
  },
  switchLang: function switchLang(state, payload) {
    state.lang = payload;
  },
  setApiBase: function setApiBase(state, payload) {
    state.env.api_base = payload;
  },
  setApiSecret: function setApiSecret(state, payload) {
    state.env.api_secret = payload;
  },
  setApiID: function setApiID(state, payload) {
    state.env.api_id = payload;
  },
  setToken: function setToken(state, payload) {
    state.env.api_token = payload;
    state.user.isLoggedIn = true;
  },
  setUser: function setUser(state, payload) {
    state.user.name = payload.name;
    state.user.email = payload.email;
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vv34":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtIQ":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__("0QuU");
icon.register({
  'eye': {
    width: 16,
    height: 16,
    viewBox: '0 0 32.13 21.88',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M25.87 3.08a17.54 17.54 0 0 1 6.25 7.86 17.53 17.53 0 0 1-6.25 7.86 17.18 17.18 0 0 1-19.62 0A17.52 17.52 0 0 1 0 10.94a17.53 17.53 0 0 1 6.25-7.86 17.18 17.18 0 0 1 19.62 0zm-4.65 13a7.26 7.26 0 1 0-5.16 2.15 7.25 7.25 0 0 0 5.17-2.13zm-2.08-8.22a4.17 4.17 0 0 1 1.23 3.08 4.21 4.21 0 0 1-4.31 4.31 4.21 4.21 0 0 1-4.31-4.31A4.17 4.17 0 0 1 13 7.86a4.29 4.29 0 0 1 6.15 0z" id="Ebene_1" data-name="Ebene 1"/></g>'
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Navbar_vue__ = __webpack_require__("DIWV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Sidebar_vue__ = __webpack_require__("EfUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_common_Navbar_vue__["a" /* default */], Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_common_Sidebar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showBare: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['env'])),
  created: function created() {
    this.showBare = !this.$route.meta.requiresAuth;
  },

  watch: {
    '$route': function $route(a) {
      this.showBare = !a.meta.requiresAuth;
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84b40070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("LbEa");
function injectStyle (ssrContext) {
  __webpack_require__("fHM9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84b40070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84b40070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xSQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassReset_vue__ = __webpack_require__("Gp5W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008e7ab1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassReset_vue__ = __webpack_require__("yMop");
function injectStyle (ssrContext) {
  __webpack_require__("gqt1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-008e7ab1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PassReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008e7ab1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yMop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"header"},[_c('b',[_vm._v(_vm._s(_vm.$t('login.password_reset.heading')))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('p',{staticClass:"helper"},[_vm._v(_vm._s(_vm.$t('login.password_reset.info')))]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('login.email')))]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"text-input",attrs:{"type":"text","name":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('button',{staticClass:"btn btn-block",on:{"click":_vm.resetRequest}},[_vm._v(_vm._s(_vm.$t('login.password_reset.heading'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('router-link',{attrs:{"to":{ name: 'Login'},"tag":"a"}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('login.back'))+"\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zIk5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "znuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: 'post',
    url: 'reset',
    baseURL: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.env.api_base,
    headers: {
      'Accept': 'application/json'
    },
    data: data
  });
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3afa8c5a02f1d7592469.js